// src/storeVisits/monthlyEmail.js — the monthly SVR email panel (v131.13).
// Lives on the admin Visits > Targets sub-tab, under the targets editor:
// enable toggle, the editable audience (Matt: "input the e-mail audience and
// be able to update / change it"), last-send status, send-test, send-now.
// All decisions live in the Worker; this panel only reads and writes config.

function api(path, opts) {
  return fetch(DB.workerUrl() + path, Object.assign({
    cache: 'no-store',
    headers: { Authorization: 'Bearer ' + DB.getToken(), 'Content-Type': 'application/json' },
  }, opts || {}));
}
function esc(s) {
  return (typeof escapeHtml === 'function') ? escapeHtml(String(s == null ? '' : s))
    : String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}
function toast(msg, kind) { if (typeof showToast === 'function') showToast(msg, kind || 'info'); }

export async function renderMonthlyEmailPanel() {
  let host = document.getElementById('svrMonthlyPanel');
  if (!host) {
    const targetsRoot = document.getElementById('visit-targets-root');
    if (!targetsRoot) return;
    host = document.createElement('div');
    host.id = 'svrMonthlyPanel';
    targetsRoot.parentNode.appendChild(host);
  }
  host.innerHTML = '<div style="color:var(--sub);font-size:13px;margin-top:18px">Loading monthly email settings…</div>';
  let d = null;
  try {
    const res = await api('/api/admin/svr-monthly');
    d = await res.json().catch(() => null);
    if (!res.ok || !d || !d.ok) throw new Error((d && d.error) || 'load failed');
  } catch (e) {
    host.innerHTML = '<div style="color:var(--danger-deep);font-size:13px;margin-top:18px">Monthly email settings could not load: ' + esc(e.message) + '</div>';
    return;
  }
  const last = d.last
    ? esc((d.last.outcome || '?') + ' · ' + (d.last.month || '') + (d.last.to ? ' · to ' + d.last.to + ' recipient(s)' : '') + ' · ' + String(d.last.at || '').slice(0, 16).replace('T', ' '))
    : 'never sent yet';
  host.innerHTML =
    '<div style="border:1px solid var(--border);border-radius:12px;padding:16px;margin-top:20px;max-width:560px">' +
    '<div style="font-size:15px;font-weight:800;margin-bottom:2px">📬 Monthly visit-report email</div>' +
    '<div style="font-size:12px;color:var(--sub,#667);margin-bottom:12px">Sent on the 1st about the month just ended: visits per area manager, every store vs target with RAG, and an AI summary of the red stores. Last: ' + last + '</div>' +
    '<label style="display:flex;align-items:center;gap:8px;font-size:13.5px;font-weight:700;cursor:pointer;margin-bottom:10px">' +
    '<input type="checkbox" id="svrMonEnabled"' + (d.enabled ? ' checked' : '') + '> Send automatically each month</label>' +
    '<div style="font-size:12.5px;font-weight:700;margin-bottom:4px">Audience — one email address per line</div>' +
    '<textarea id="svrMonRecipients" style="width:100%;min-height:84px;padding:9px;border:1px solid var(--border);border-radius:9px;font:inherit;font-size:13px" placeholder="e.g. matt@example.com">' + esc((d.recipients || []).join(String.fromCharCode(10))) + '</textarea>' +
    '<div style="display:flex;gap:8px;margin-top:10px;flex-wrap:wrap">' +
    '<button onclick="StoreVisits.saveMonthlyEmail()" style="background:var(--brand,#009E3D);color:#fff;border:none;border-radius:9px;padding:8px 14px;font-size:13px;font-weight:700;cursor:pointer">Save</button>' +
    '<button onclick="StoreVisits.testMonthlyEmail()" style="background:none;border:1px solid var(--border);border-radius:9px;padding:8px 14px;font-size:13px;cursor:pointer">Send a test to me</button>' +
    '<button onclick="StoreVisits.sendMonthlyEmail()" style="background:none;border:1px solid var(--border);border-radius:9px;padding:8px 14px;font-size:13px;cursor:pointer">Send now to the audience</button>' +
    '</div>' +
    '<div id="svrMonMsg" style="font-size:12px;color:var(--sub,#667);margin-top:8px"></div>' +
    '</div>';
}

function readForm() {
  const enabled = !!(document.getElementById('svrMonEnabled') || {}).checked;
  const recipients = String((document.getElementById('svrMonRecipients') || {}).value || '')
    .split(/[\n,;]+/).map((s) => s.trim()).filter(Boolean);
  return { enabled, recipients };
}

export async function saveMonthlyEmail() {
  const f = readForm();
  try {
    const res = await api('/api/admin/svr-monthly/config', { method: 'POST', body: JSON.stringify(f) });
    const d = await res.json().catch(() => null);
    if (!res.ok || !d || !d.ok) throw new Error((d && d.error) || 'save failed');
    // the server VALIDATED the addresses - show what actually stuck, so a
    // typo'd address visibly disappears instead of silently not saving
    toast('Saved — ' + d.recipients.length + ' recipient(s), ' + (d.enabled ? 'ON' : 'OFF'), 'success');
    renderMonthlyEmailPanel();
  } catch (e) { toast(e.message || 'Could not save', 'error'); }
}

export async function testMonthlyEmail() {
  const me = window.prompt('Send the test to which email address?');
  if (!me) return;
  try {
    const res = await api('/api/admin/svr-monthly/send', { method: 'POST', body: JSON.stringify({ test_to: me }) });
    const d = await res.json().catch(() => null);
    if (!res.ok || !d || !d.ok) throw new Error((d && d.reason) || (d && d.error) || 'send failed');
    toast('Test sent to ' + me + (d.aiOk === false ? ' (AI summary unavailable — facts only)' : ''), 'success');
  } catch (e) { toast(e.message || 'Could not send the test', 'error'); }
}

export async function sendMonthlyEmail() {
  if (!window.confirm('Send the monthly visit-report email to the configured audience NOW?')) return;
  try {
    const res = await api('/api/admin/svr-monthly/send', { method: 'POST', body: JSON.stringify({}) });
    const d = await res.json().catch(() => null);
    if (!res.ok || !d || !d.ok) throw new Error((d && d.reason) || (d && d.error) || 'send failed');
    toast('Sent to ' + d.to.length + ' recipient(s)', 'success');
    renderMonthlyEmailPanel();
  } catch (e) { toast(e.message || 'Could not send', 'error'); }
}
